export default function formatDate(dateInput) {
  if (!dateInput) return "";

  // If it's a range: "10 December 2025 - 09 January 2026"
  if (dateInput.includes(" - ")) {
    const [start, end] = dateInput.split(" - ");

    return `${formatSingleDate(start)} - ${formatSingleDate(end)}`;
  }

  // If it's a single date
  return formatSingleDate(dateInput);
}

function formatSingleDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // Dec
  const year = date.getFullYear(); // 2025

  return `${day} ${month} ${year}`;
}
